import { Injectable, inject } from '@angular/core';
import { ConversationChannel, ParticipantType } from '@vendasta/conversation';
import { Observable, map, of } from 'rxjs';
import { InboxService } from '../inbox.service';
import { ConversationDetail } from '../interface/conversation.interface';
import { CONVERSATION_COUNTRY_TOKEN } from '../tokens';
import { AlertOptions, ConversationChannelService } from './conversation-channel.abstract';
import { InboxAlertService } from './inbox-alert.service';

@Injectable()
export class ConversationPlatformService extends ConversationChannelService {
  private readonly inboxService = inject(InboxService);
  private readonly country$ = inject(CONVERSATION_COUNTRY_TOKEN);
  private readonly inboxAlerter = inject(InboxAlertService);

  getChatComposerAlert(
    partnerId: string,
    accountGroupId: string,
    conversationDetail: ConversationDetail,
  ): Observable<AlertOptions | null> {
    if (conversationDetail.conversation.channel !== ConversationChannel.CONVERSATION_CHANNEL_INTERNAL) return of(null);
    // for business app form submission contacts conversations are created in either email or sms channel
    // but just in case exit early
    if (this.inboxService.isBusinessApp) return of(null);

    // for partners there should only one customer in one specific platform conversation (i.e. from form submission)
    const customerParticipant = conversationDetail?.participants?.find(
      (participant) => participant.participantType === ParticipantType.PARTICIPANT_TYPE_CUSTOMER,
    );
    if (!customerParticipant || (!customerParticipant.phoneNumber && !customerParticipant.email)) return of(null);

    return this.country$.pipe(
      map((country) => {
        return this.inboxAlerter.smsOrEmailNotAvailableForCapturedLeadError(
          customerParticipant.phoneNumber,
          customerParticipant.email,
          country,
        );
      }),
    );
  }
}
